import { render, staticRenderFns } from "./PrivilegeHistoryDetail.vue?vue&type=template&id=7029e68a&scoped=true&"
import script from "./PrivilegeHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./PrivilegeHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeHistoryDetail.vue?vue&type=style&index=0&id=7029e68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029e68a",
  null
  
)

export default component.exports